export type Interpolations = Readonly<Record<string, number | string>>;

const PLACEHOLDER = /\{\{(\w+)\}\}/g;

export function interpolate(template: string, values: Interpolations): string {
  return template.replace(PLACEHOLDER, (match: string, key: string) => {
    const value = values[key];
    return value === undefined ? match : String(value);
  });
}

export function interpolateFaqs<T extends { a: string; q: string }>(
  faqs: readonly T[],
  values: Interpolations,
): readonly { a: string; q: string }[] {
  return faqs.map(({ a, q }) => ({ a: interpolate(a, values), q: interpolate(q, values) }));
}
